import { ListingType } from "../types/userListing";

interface AutopilotGateListing {
    listingType?: ListingType | string;
    sharedListing?: boolean;
    status?: string;
}

// MB-1436, widened by MB-1441: while Autopilot is on there are no manual
// listing campaigns at all - any listing type, any status. The api 409s
// (AUTOPILOT_MANAGED_LISTING) regardless of the listing, so the UI hides the
// action for every listing once the flag is known. The listing argument is
// kept so call sites stay uniform, but nothing about it changes the answer
// anymore.
export const isAutopilotManagedListing = (
    autopilotEnabled: boolean | null,
    _listing: AutopilotGateListing,
): boolean => {
    return autopilotEnabled === true;
};

// True while the Autopilot flag is still in flight. Callers withhold the
// manual action until the answer is known, so it is never shown and then
// pulled away mid-click.
export const isAutopilotManagedListingPending = (
    autopilotLoading: boolean,
    _listing: AutopilotGateListing,
): boolean => {
    return autopilotLoading;
};
